/* global OfficeRuntime */
import { getValidToken } from "./auth";

export interface Coordinate {
    cadastral_reference: string;
    lat: number;
    lng: number;
}

export interface ZoneResult {
  zone_id: number;
  zone_name: string;
  point_wkt: string;
}

const API_BASE =
  process.env.NODE_ENV === "production"
    ? "https://zoneagent.winstonwolf-capital.com/api"
    : "https://dev-zoneagent.winstonwolf-capital.com/api";

export async function checkCoordinates(coords: Coordinate[]): Promise<any> {
  const token = await getValidToken();

  const res = await fetch(`${API_BASE}/coordinates/check`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify({ coordinates: coords }),
  });

  if (!res.ok) {
    throw new Error(`API error ${res.status}: ${await res.text()}`);
  }

  return res.json();
}

